<template>
  <PageLayout class="custom-poll-page">
    <template slot="header">
      <div class="d-flex m-3">
        <Breadcrumb :list="breadcrumbList" />
        <Dropdown
          :data="groupOptions"
          :selectedId="selected"
          @selectItem="groupSelected"
          :showSearch="true"
        />
        <ExportData
          id="exportData"
          class="ml-sm-2 mt-2 mt-sm-0"
          :canExport="$can('use', 'report.export')"
          :hasXlsx="true"
          :hasCsv="false"
          @export="exportFile"
        />
      </div>
    </template>
    <template slot="main">
      <div v-if="!report.status" class="loading">
        <Loading />
        <p>{{ label.loading }}</p>
      </div>
      <div v-if="report.status">
        <GeneralMetric :report="report" :surveyLink="surveyLink" class="mb-2" />
        <QuestionMetric
          v-for="(question, $index) in questions"
          :key="$index"
          :number="$index + 1"
          :question="question"
          class="mb-3"
        />
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageLayout from '@/components/Home/PageLayout.vue'
import QuestionMetric from '@/components/CustomPoll/Reports/QuestionMetric.vue'
import Dropdown from '@/components/Shared/Form/Dropdown.vue'
import GeneralMetric from '@/components/CustomPoll/Reports/GeneralMetric.vue'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import Loading from '@/components/Shared/Loading.vue'
import ExportData from '@/components/Reports/ExportData.vue'

export default {
  components: {
    PageLayout,
    QuestionMetric,
    GeneralMetric,
    Breadcrumb,
    Dropdown,
    Loading,
    ExportData,
  },
  data() {
    return { selected: 'consolidate' }
  },
  computed: {
    ...mapGetters({
      report: 'customPoll/report',
      groups: 'customPoll/groups',
    }),
    ...mapGetters({
      metric: 'metric/metric',
      resources: 'resources',
    }),
    questions() {
      return 'questions' in this.report ? this.report.questions : []
    },
    groupOptions() {
      return {
        groups: [
          {
            id: undefined,
            _id: 'consolidate',
            name: this.resources.page.customPoll.consolidate,
            isConsolidate: true,
          },
          ...Object.values(this.groups).map(group => ({
            ...group,
            _id: group.id,
          })),
        ],
      }
    },
    breadcrumbList() {
      return [
        {
          label: this.resources.general.menu.customPoll,
          link: { name: 'customPoll' },
        },
        {
          label: this.resources.general.menu.report,
        },
      ]
    },
    label() {
      return this.resources.page.customPoll.dashboard
    },
    surveyLink() {
      return `${window.location.origin}/custom-poll/survey/${this.$route.params.pollId}`
    },
  },
  methods: {
    groupSelected(group) {
      this.selected = group._id
      const pollId = this.$route.params.pollId
      const request = { pollId, groupId: group.id }
      this.$store.dispatch('customPoll/getPollReport', request)
    },
    exportFile() {
      const env = window.env || process.env

      const { pollId } = this.$route.params
      const groupId = this.selected

      window.open(
        `${env.VUE_APP_EXPORTER_API_HOST}/polls/${pollId}/xlsx?group_id=${groupId}&token=${localStorage.jwt}&language=${localStorage.languageabrev}`,
        '_blank'
      )
    },
  },
  beforeCreate() {
    const pollId = this.$route.params.pollId
    this.$store.dispatch('customPoll/getPollGroups', { pollId })
    this.$store.dispatch('customPoll/getPollReport', { pollId })
  },
  beforeDestroy() {
    this.$store.dispatch('customPoll/resetReports')
  },
  mounted() {
    // adicionar titulo nessa pagina
    this.$root.$emit('track', {
      event: 'Acessou Relatorio de Pesquisas Personalizadas',
      data: {
        category: 'App',
      },
    })
  },
}
</script>

<style lang="scss" scoped>
header {
  .d-flex {
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
.loading {
  margin: 0 auto;
  text-align: center;
}
</style>
